<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="nombre">Nombre</label>
          <input
            type="text"
            class="form-control form-control-sm"
            id="nombre"
            readonly="readonly"
            v-model="formGeocerca.nombre"
            :class="$v.formGeocerca.nombre.$invalid ? 'is-invalid' : 'is-valid'"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="tipo_geocerca">Tipo Geocerca</label>
          <select
            class="form-control form-control-sm"
            v-model="formGeocerca.tipo_geocerca"
            :class="
              $v.formGeocerca.tipo_geocerca.$invalid ? 'is-invalid' : 'is-valid'
            "
          >
            <option value="">Seleccione...</option>
            <option
              v-for="tipo_geocerca in listasForms.tipos_geocerca"
              :key="tipo_geocerca.numeracion"
              :value="tipo_geocerca.numeracion"
            >
              {{ tipo_geocerca.descripcion }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="estado">Estado</label>
          <select
            class="form-control form-control-sm"
            v-model="formGeocerca.estado"
            :class="$v.formGeocerca.estado.$invalid ? 'is-invalid' : 'is-valid'"
          >
            <option value="">Seleccione...</option>
            <option
              v-for="estado in $parent.listasForms.estados"
              :key="estado.id"
              :value="estado.id"
            >
              {{ estado.descripcion }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <button
          class="btn btn-primary float-right mt-4"
          v-show="!$v.formGeocerca.$invalid"
          @click="saveGeocerca()"
        >
          <i class="fas fa-save"></i>
        </button>
      </div>
    </div>
    <div class="row" v-if="formGeocerca != null">
      <div class="col-md-12">
        <BloqueMapPoli
          v-if="formGeocerca.tipo_geocerca == 1"
          v-show="!$v.formGeocerca.$invalid"
          ref="BloqueMapPoli"
        />
        <BloqueMapCir
          v-if="formGeocerca.tipo_geocerca == 2"
          v-show="!$v.formGeocerca.$invalid"
          ref="BloqueMapCir"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import BloqueMapPoli from "./BloqueMapPoli.vue";
import BloqueMapCir from "./BloqueMapCir.vue";

export default {
  name: "BloqueGeocerca",
  components: {
    BloqueMapPoli,
    BloqueMapCir,
  },
  data() {
    return {
      formGeocerca: {
        tipo_geocerca: null,
        nombre: null,
        estado: null,
      },
      estado: null,
      listasForms: {
        tipos_geocerca: [],
      },
    };
  },

  validations: {
    formGeocerca: {
      tipo_geocerca: {
        required,
      },
      nombre: {
        required,
      },
      estado: {
        required,
      },
    },
  },

  methods: {
    getIndex() {
      if (this.$parent.form.geocerca != null) {
        this.form = this.$parent.form.geocerca;
        this.formGeocerca.geocerca_id = this.form.id;
        this.formGeocerca.tipo_geocerca = this.form.tipo_geocerca;
        this.formGeocerca.estado = this.form.estado;
      } else {
        if (this.$parent.sitios[0] !== undefined) {
          this.formGeocerca = {
            latitud: this.$parent.sitios[0].latitud,
            longitud: this.$parent.sitios[0].longitud,
            radio: 1000,
          };
        }
      }

      this.formGeocerca.nombre = "GEOCERCA BLOQUE " + this.$parent.form.nombre;
    },
    getTiposGeocerca() {
      axios.get("/api/lista/29").then((response) => {
        this.listasForms.tipos_geocerca = response.data;
      });
    },
    saveGeocerca() {
      this.$parent.cargando = true;
      this.formGeocerca.sitio_id = this.$parent.form.id;

      if (this.formGeocerca.tipo_geocerca == 1) {
        this.formGeocerca.longitud = this.$refs.BloqueMapPoli.paths[0][0].lng;
        this.formGeocerca.latitud = this.$refs.BloqueMapPoli.paths[0][0].lat;
        this.formGeocerca.paths = this.$refs.BloqueMapPoli.paths[0];
      } else {
        this.formGeocerca.longitud = this.$refs.BloqueMapCir.reportedCenter.lng;
        this.formGeocerca.latitud = this.$refs.BloqueMapCir.reportedCenter.lat;
        this.formGeocerca.radio = this.$refs.BloqueMapCir.radius;
      }

      if (!this.$v.formGeocerca.$invalid) {
        axios({
          method: "PUT",
          url: "/api/admin/bloques/saveGeocerca",
          data: this.formGeocerca,
        })
          .then((response) => {
            this.$parent.cargando = false;
            this.formGeocerca.geocerca_id = response.data.id;
            this.$swal({
              icon: "success",
              title: "Se guardo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((e) => {
            this.$parent.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
  },

  beforeMount() {
    this.getTiposGeocerca();
  },

  mounted() {
    this.getIndex();
  },
};
</script>
